import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { MyProximusAuthenticationCheckGuard } from '../guards/myproximus-authentication-check.guard';
import { NspActivationContainerComponent } from './nsp-activation-container/nsp-activation-container.component';
import { NspActivationInternetContainerComponent } from './nsp-activation-internet-container/nsp-activation-internet-container.component';
import { NspActivationMobileContainerComponent } from './nsp-activation-mobile-container/nsp-activation-mobile-container.component';
import { NspManageContainerComponent } from './nsp-manage-container/nsp-manage-container.component';

const routes: Routes = [
  {
    path: 'nspActivation',
    component: NspActivationContainerComponent,
    canActivate: [MyProximusAuthenticationCheckGuard],
    data: {
      analytics: {
        page: {
          name: 'myproducts proximus secure net',
          id: 'myproducts proximus secure net',
          category: {
            l1: 'myproximus',
            l2: 'myproducts',
            l3: 'nsp',
          },
        },
      },
    },
  },
  {
    path: 'nspActivationInternet',
    component: NspActivationInternetContainerComponent,
    canActivate: [MyProximusAuthenticationCheckGuard],
    data: {
      analytics: {
        page: {
          name: 'myproducts proximus secure net internet',
          id: 'myproducts proximus secure net internet',
          category: {
            l1: 'myproximus',
            l2: 'myproducts',
            l3: 'nsp',
            l4: 'step 1',
          },
        },
      },
    },
  },
  {
    path: 'nspActivationMobile',
    component: NspActivationMobileContainerComponent,
    canActivate: [MyProximusAuthenticationCheckGuard],
    data: {
      analytics: {
        page: {
          name: 'myproducts proximus secure net mobile',
          id: 'myproducts proximus secure net mobile',
          category: {
            l1: 'myproximus',
            l2: 'myproducts',
            l3: 'nsp',
            l4: 'step 2',
          },
        },
      },
    },
  },
  {
    path: 'nspManage',
    component: NspManageContainerComponent,
    canActivate: [MyProximusAuthenticationCheckGuard],
    data: {
      analytics: {
        page: {
          name: 'myproducts proximus secure net',
          id: 'myproducts proximus secure net',
          category: {
            l1: 'myproximus',
            l2: 'myproducts',
            l3: 'nsp',
            l4: 'manage',
          },
        },
      },
    },
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class NspRoutingModule {}
